export default "__VITE_ASSET__dca52d6f__"